export const TEST_ID_ABOUT_ROOM_BTN = 'about-room-button';
